export default "__VITE_ASSET__YBOxyfIU__"